<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/comparison-table.html" name="c-comparison-table">
<link rel="ractive" href="../components/header-gradient.html" name="c-header-gradient">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-header useWhiteLogos="true" additionalClasses="header-with-orange-bg"></c-header>

	<div class="p-unpkg">
		<c-header-gradient showMap="{{ true }}"></c-header-gradient>

		<div class="content">
			<div class="title">
				<h1>Migrating from unpkg to jsDelivr</h1>

				<h2>
					jsDelivr is a free, fast, and reliable Open Source CDN for npm and GitHub.
					Most unpkg links can be easily converted to jsDelivr links.
				</h2>
			</div>

			<div class="container">
				<div class="box">
					<div class="bar {{#if out && !error}}bar-active{{/if}}">
						<div class="circle"></div>
						<div class="line {{#if out && !error}}filled{{/if}}"></div>
						<div class="circle bottom {{#unless out && !error}}circle-disabled{{/unless}}"></div>
					</div>

					<div class="icon-competitor">
						<img width="91" height="50" src="{{@shared.assetsHost}}/img/unpkg.png" srcset="{{@shared.assetsHost}}/img/unpkg@2x.png 2x">
					</div>

					<div class="input-wrapper mb-48">
						<input type="text" class="input {{#if out}}active{{/if}}" placeholder="Paste an unpkg link here" value="{{in}}">
					</div>

					<div class="icon-jsdelivr">
						<img width="115" height="28" src="{{@shared.assetsHost}}/img/jsDelivr.logo.svg">
					</div>

					<div class="input-wrapper">
						<input type="text" class="input {{#if out && !error}}input-jsdelivr-copy{{/if}} {{#if out}}active{{/if}}" placeholder="Get a jsDelivr link here" value="{{out}}">

						{{#if out && !error}}
							<a class="copy" as-clipboard data-clipboard-text="{{out}}">Copy</a>
						{{/if}}
					</div>

					{{#if displayHtmlWarning}}
						<div class="alert alert-warning" role="alert">
							For security reasons, we serve HTML files with <code>Content-Type: text/plain</code>.
							We recommend using <a href="https://pages.github.com/" target="_blank" rel="noopener noreferrer">GitHub Pages</a> if this is a problem.
						</div>
					{{/if}}
				</div>

				<div class="host-descr-title">
					unpkg and jsDelivr comparison
				</div>

				<div class="host-descr-text">
					jsDelivr is a great alternative for unpkg and offers many advanced features like direct npm and github integration, file minification, and ES modules compilation and optimized delivery. In addition to that jsDelivr is faster thanks to it's global infrastructure that utilizes multiple CDN providers
				</div>
			</div>

			<div class="container">
				<c-comparison-table
					competitorImgSrc="{{@shared.assetsHost}}/img/unpkg.png"
					competitorImgWidth="91"
					competitorImgHeight="50"
					competitorImgSrcset="{{@shared.assetsHost}}/img/unpkg@2x.png 2x">
				</c-comparison-table>

				<div class="buttons">
					<a href="/" class="all-features">See All Features</a>
				</div>
			</div>
		</div>
	</div>

	<c-footer></c-footer>
</r-page>

<script>
	/* eslint-disable no-throw-literal */

	const debounce = require('../../assets/js/utils/debounce');
	const throttle = require('../../assets/js/utils/throttle');
	const clipboard = require('../../assets/js/decorators/clipboard');
	const defaultError = 'Sorry, this doesn\'t look like a valid unpkg link :(';

	component.exports = {
		decorators: {
			clipboard,
		},
		data () {
			return {
				title: 'Migrate from unpkg to jsDelivr',
				description: 'Migrate from unpkg to jsDelivr - a free, fast, and reliable Open Source CDN optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.',
			};
		},
		oninit () {
			let buildJsDelivrLink = (esm, [ , name, version, file ]) => {
				return `${esm ? 'https://esm.run/' : 'https://cdn.jsdelivr.net/npm/'}${name}${version || ''}${file || ''}`;
			};

			let unpkg2jsDelivr = unpkg => Promise.resolve().then(() => {
				let pattern = /^https?:\/\/unpkg\.com\/([^/@?]+|@[^/@?]+\/[^/@?]+)(@[^/?]+)?([^?]*\/[^?]*)*(\?module)?$/i;
				let match = pattern.exec(unpkg);

				if (match) {
					return buildJsDelivrLink(!!match[4], match);
				}

				throw defaultError;
			});

			this.observe('in', debounce(throttle((unpkg) => {
				this.set('displayHtmlWarning', unpkg.slice(-5) === '.html');

				if (!unpkg) {
					return this.set('out', '');
				}

				unpkg2jsDelivr(unpkg).then((jsDelivr) => {
					this.set('error', false);

					if (this.get('in') === unpkg) {
						this.set('out', jsDelivr);
					}
				}).catch((error) => {
					this.set('error', true);
					this.set('out', typeof error === 'string' ? error : defaultError);
				});
			}, 1000)));
		},
	};
</script>
